/**
 * @flow
 * @relayHash 2c678822c098c45c1b7704da7ffeb2e6
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type PaymentModeCreateInput = {|
  name: string
|};
export type CreatePaymentModeMutationVariables = {|
  data: PaymentModeCreateInput
|};
export type CreatePaymentModeMutationResponse = {|
  +createPaymentMode: {|
    +id: string
  |}
|};
export type CreatePaymentModeMutation = {|
  variables: CreatePaymentModeMutationVariables,
  response: CreatePaymentModeMutationResponse,
|};
*/


/*
mutation CreatePaymentModeMutation(
  $data: PaymentModeCreateInput!
) {
  createPaymentMode(data: $data) {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "data",
    "type": "PaymentModeCreateInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "createPaymentMode",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "data",
        "variableName": "data"
      }
    ],
    "concreteType": "PaymentModeModel",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "CreatePaymentModeMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "CreatePaymentModeMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "CreatePaymentModeMutation",
    "id": null,
    "text": "mutation CreatePaymentModeMutation(\n  $data: PaymentModeCreateInput!\n) {\n  createPaymentMode(data: $data) {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'a8344a7dbbf645780c55bd68c1fa73ab';
module.exports = node;
